import { Input } from '@/client/components/ui/input';
import { Label } from '@/client/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/client/components/ui/select';

export type ProjectFormState = {
  name: string;
  description: string;
  status: 'active' | 'on_hold' | 'completed';
  client_name: string;
};

export const emptyProjectForm: ProjectFormState = {
  name: '',
  description: '',
  status: 'active',
  client_name: '',
};

interface ProjectFormFieldsProps {
  form: ProjectFormState;
  setForm: React.Dispatch<React.SetStateAction<ProjectFormState>>;
}

export function ProjectFormFields({ form, setForm }: ProjectFormFieldsProps) {
  return (
    <>
      <div className="space-y-1.5">
        <Label htmlFor="pf-name">Name</Label>
        <Input
          id="pf-name"
          required
          value={form.name}
          onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="pf-description">Description</Label>
        <Input
          id="pf-description"
          value={form.description}
          onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))}
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="pf-status">Status</Label>
        <Select
          value={form.status}
          onValueChange={(v) => setForm((f) => ({ ...f, status: v as ProjectFormState['status'] }))}
        >
          <SelectTrigger id="pf-status">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="active">Active</SelectItem>
            <SelectItem value="on_hold">On Hold</SelectItem>
            <SelectItem value="completed">Completed</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="pf-client">Client Name</Label>
        <Input
          id="pf-client"
          value={form.client_name}
          onChange={(e) => setForm((f) => ({ ...f, client_name: e.target.value }))}
        />
      </div>
    </>
  );
}
